<template>
    <Carousel :minHeight="226"
        class="carousel"
        loop
        dots
        :nav="false"
    >
        <div class="intro-item"
            v-for="item in cloudIntros"
            :class="{e2ee: item.img === E2eeImg }"
            :key="item.title"
            :style="{backgroundImage: `url(${item.img})`}"
        >
            <h3 class="title">{{ item.title }}</h3>
            <p class="desc">{{ item.desc }}</p>
        </div>
    </Carousel>
</template>

<script lang="ts">
import Vue from 'vue';
import Carousel from '@/basic/Carousel.vue';
import IntroImg from 'IMAGE/homepage/carousel/01.jpg';
import ReplyImg from 'IMAGE/homepage/carousel/02.jpg';
import AiImg from 'IMAGE/homepage/carousel/03.jpg';
import RichImg from 'IMAGE/homepage/carousel/04.jpg';
import E2eeImg from 'IMAGE/homepage/carousel/05.jpg';
interface IIntroItem {
    img: string;
    title: string;
    desc: string;
}

export default Vue.extend({
    components: {
        Carousel
    },
    data() {

        return {
            E2eeImg
        };

    },
    computed: {
        cloudIntros(): IIntroItem[] {

            return [{
                img: IntroImg,
                title: this.$t( 'homepage.intros.cloud_intro_title' ) as string,
                desc: this.$t( 'homepage.intros.cloud_intro_des' ) as string,
            }, {
                img: ReplyImg,
                title: this.$t( 'homepage.intros.replay_intro_title' ) as string,
                desc: this.$t( 'homepage.intros.replay_intro_title_des' ) as string,
            }, {
                img: RichImg,
                title: this.$t( 'homepage.intros.rich_intro_title' ) as string,
                desc: this.$t( 'homepage.intros.rich_intro_des' ) as string,
            }, {
                img: AiImg,
                title: this.$t( 'homepage.intros.ai_search_intro_title' ) as string,
                desc: this.$t( 'homepage.intros.ai_search_intro_des' ) as string,
            }, {
                img: E2eeImg,
                title: this.$t( 'homepage.intros.e2ee_intro_title' ) as string,
                desc: this.$t( 'homepage.intros.e2ee_intro_des' ) as string,
            }];

        }
    }
});
</script>

<style lang="less" scoped>
.intro-item{
    width: auto;
    aspect-ratio: 315/226;
    background-position: bottom center;
    padding: 30px 13px;
    box-sizing: border-box;
    text-align: center;
    border-radius: @border-radius-level-button;
    background-size: cover;
    &.e2ee{
        background-size: auto 120%;
        background-position: bottom 100% center;
    }

    .title{
        font-size: 24px;
        font-weight: 600;
    }

    .desc{
        font-size: 12px;
        margin-top: 4px;
    }
}
.carousel{
    padding-top: 20px;
    left: 0px;
    transform: none;
    justify-content: flex-end;
    /deep/ .owl-carousel{
        width: calc(100% - 20px);
    }
}
/deep/ .owl-dots{
    display: flex;
    gap: 6px;
    margin-top: 13px;
    justify-content: center;
}
/deep/ .owl-dot{
    width: 5px;
    height: 5px;
    background-color: @black2;
    border-radius: 100%;
    &.active{
        background-color: @black6;
    }
}
</style>
